import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueResource from "vue-resource";
import VueTheMask from "vue-the-mask";

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import light from "./styles/export_light";
import dark from "./styles/export_dark";
import "./styles/export.css";

import moment from "moment";

import VCurrencyField from "v-currency-field";

import { VTextField } from "vuetify/lib";

Vue.component("v-text-field", VTextField);
Vue.use(VCurrencyField, {
  locale: "pt-BR",
  decimalLength: 2,
  autoDecimalMode: true,
  min: null,
  max: null,
  defaultValue: 0,
  valueAsInteger: false,
  allowNegative: true,
});

Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true,
});

Vue.prototype.$light_theme = light;
Vue.prototype.$dark_theme = dark;

Vue.use(VueResource);
Vue.use(VueTheMask);
Vue.use(moment);
Vue.config.productionTip = false;
Vue.$globalEvent = new Vue();

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
  mounted() {
    Vue.$globalEvent.$on("httpError", (item) => {
      const messages = {
        401: "Falha na comunicação com o servidor",
        403: "Falha na comunicação com o servidor",
        404: "Falha na comunicação com o servidor",
        500: "Falha na comunicação com o servidor",
      };
      console.log(item);
      this.$toast.error(messages[item.body.status] || "Ocorreu um erro!");
      this.$router.push({
        name: "problem",
        query: {
          apiError: "true",
        },
        
      });
    });
  },
}).$mount("#app");
